import { render, staticRenderFns } from "./Classheads.vue?vue&type=template&id=492a7bc6&"
import script from "./Classheads.vue?vue&type=script&lang=js&"
export * from "./Classheads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports